<template>
  <div id="app">
    <main>
      <fade-transition
        :duration="250"
        origin="center"
        mode="out-in"
      >
        <router-view />
      </fade-transition>
      <b-loading
        :is-full-page="true"
        :active.sync="showGlobalLoading"
        :can-cancel="false"
      />
    </main>
  </div>
</template>
<script>
import { FadeTransition } from 'vue2-transitions'
import { mapGetters, mapActions } from 'vuex'
import {
  setLayoutPortal
} from '@/utils'

const { body } = document
const WIDTH = 992 // refer to Bootstrap's responsive design

export default {
  components: {
    FadeTransition
  },
  computed: {
    ...mapGetters([
      'isLoading',
      'suppressGlobalLoading',
      'client'
    ]),
    // Telas com indicador próprio (captura de selfie) suprimem o overlay global.
    showGlobalLoading: {
      get() {
        return this.isLoading && !this.suppressGlobalLoading
      },
      set(value) {
        this.setLoading(value)
      }
    }
  },
  created() {
    const isMobile = this.$_isMobile()
    if (isMobile) {
      this.toggleDevice('mobile')
      document.body.classList.add('mobile')
    }
    if (this.client['transaction-permition']) {
      setLayoutPortal(this.client)
    }
  },
  methods: {
    ...mapActions([
      'toggleDevice',
      'setLoading'
    ]),
    $_isMobile() {
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    }
  }
}
</script>
